import { Navigate } from 'react-router-dom';
import PatientLayout from './components/PatientLayout';
import PatientHome from './pages/PatientHome';
import HealthTimeline from './pages/HealthTimeline';
import EmergencySOS from './pages/EmergencySOS';
import ConsentSharing from './pages/ConsentSharing';
import AccessLogs from './pages/AccessLogs';
import MedicineReminders from './pages/MedicineReminders';
import InsuranceDashboard from './pages/InsuranceDashboard';
import FamilyProfiles from './pages/FamilyProfiles';
import LabTracking from './pages/LabTracking';
import PharmacyOrders from './pages/PharmacyOrders';
import FollowUpReminders from './pages/FollowUpReminders';
import PatientSettings from './pages/PatientSettings';
import CertificatesCenter from './pages/CertificatesCenter';
import HealthVault from './pages/HealthVault';
import ShareCenter from './pages/ShareCenter';
import NeoAI from './pages/NeoAI';
import Vaccinations from './pages/Vaccinations';
import BloodBankReadiness from './pages/BloodBankReadiness';
import EcosystemLinksPage from './pages/EcosystemLinksPage';
import ClaimsDocPack from './pages/ClaimsDocPack';
import EmergencyRecords from './pages/EmergencyRecords';
import MyChat from './pages/MyChat';
import CertificatePreview from './pages/CertificatePreview';
import DocumentPreview from './pages/DocumentPreview';
import DocumentTemplates from './pages/DocumentTemplates';
import DocumentDownloads from './pages/DocumentDownloads';
// Lab Integration Demo
import PatientLabDiscovery from './pages/PatientLabDiscovery';
import PatientLabProfile from './pages/PatientLabProfile';
import PatientLabBooking from './pages/PatientLabBooking';
import PatientLabAppointments from './pages/PatientLabAppointments';
import PatientLabAppointmentDetail from './pages/PatientLabAppointmentDetail';
import PatientLabReports from './pages/PatientLabReports';
import PatientLabInvoices from './pages/PatientLabInvoices';
import PatientLabStore from './pages/PatientLabStore';
import PatientChangePassword from './pages/PatientChangePassword';
import PatientLabPayments from './pages/PatientLabPayments';
// Marketplace
import Marketplace from './pages/Marketplace';
import ProviderListing from './pages/ProviderListing';
import ProviderDetail from './pages/ProviderDetail';
// APK flow pages
import PatientNHCCard from './pages/PatientNHCCard';
import PatientCareServices from './pages/PatientCareServices';
import CareServicesHub from './pages/care-services/CareServicesHub';
import PatientProfile from './pages/PatientProfile';
import PatientNotifications from './pages/PatientNotifications';
import PatientSecurity from './pages/PatientSecurity';
import PatientSecuritySessions from './pages/PatientSecuritySessions';
import PatientTwoFactor from './pages/PatientTwoFactor';
import PatientMedicalBasics from './pages/PatientMedicalBasics';
import PatientPrescriptions from './pages/PatientPrescriptions';
import PatientDiagnostics from './pages/PatientDiagnostics';
import PatientDocuments from './pages/PatientDocuments';
import PatientRegistration from './pages/PatientRegistration';
import PatientAppointments from './pages/PatientAppointments';
import PatientQRScanner from './pages/PatientQRScanner';
import PatientSearch from './pages/PatientSearch';
import PatientAppLock from './pages/PatientAppLock';
import PatientLegalCenter from './pages/PatientLegalCenter';
import PatientLegalPage from './pages/PatientLegalPage';
// Care Services sub-pages
import DoctorDiscovery from './pages/care-services/DoctorDiscovery';
import DoctorProfile from './pages/care-services/DoctorProfile';
import DoctorBooking from './pages/care-services/DoctorBooking';
import LabDiscovery from './pages/care-services/LabDiscovery';
import LabTestsCatalogue from './pages/care-services/LabTestsCatalogue';
import LabStore from './pages/care-services/LabStore';
import LabBooking from './pages/care-services/LabBooking';
import PharmacyDiscovery from './pages/care-services/PharmacyDiscovery';
import PharmacyStore from './pages/care-services/PharmacyStore';
import ImagingDiscovery from './pages/care-services/ImagingDiscovery';
import ImagingCenter from './pages/care-services/ImagingCenter';
import HospitalDiscovery from './pages/care-services/HospitalDiscovery';
import HospitalProfile from './pages/care-services/HospitalProfile';
import TelemedicinePage from './pages/care-services/TelemedicinePage';
import TeleConsultPage from './telemed/TeleConsultPage';
import AmbulancePage from './pages/care-services/AmbulancePage';
import InsurancePage from './pages/care-services/InsurancePage';
import PharmacyReceiptViewer from './pages/PharmacyReceiptViewer';
import HospitalRecord from './pages/HospitalRecord';
import AmbulanceTrips from './pages/AmbulanceTrips';
import MyRequests from './pages/MyRequests';
import NeoVerifyCheck from './pages/NeoVerifyCheck';
import AddressesAndPreferences from './pages/AddressesAndPreferences';
import CarePlans from './pages/CarePlans';
import NearbyCare from './pages/NearbyCare';
import MyCare from './pages/MyCare';
import LabCompare from './pages/care-services/LabCompare';
import HospitalPanelPage from './pages/care-services/HospitalPanel';

export const patientRoutes = {
  path: 'patient',
  element: <PatientLayout />,
  children: [
    { index: true, element: <PatientHome /> },
    { path: 'home', element: <PatientHome /> },
    { path: 'timeline', element: <HealthTimeline /> },
    { path: 'emergency', element: <EmergencySOS /> },
    { path: 'consent', element: <ConsentSharing /> },
    { path: 'access-logs', element: <AccessLogs /> },
    { path: 'medicines', element: <MedicineReminders /> },
    { path: 'insurance', element: <InsuranceDashboard /> },
    { path: 'family', element: <FamilyProfiles /> },
    { path: 'lab', element: <LabTracking /> },
    { path: 'pharmacy', element: <PharmacyOrders /> },
    { path: 'pharmacy/receipt/:receiptId', element: <PharmacyReceiptViewer /> },
    { path: 'follow-ups', element: <FollowUpReminders /> },
    { path: 'settings', element: <PatientSettings /> },
    { path: 'change-password', element: <PatientChangePassword /> },
    // Phase 2: new routes
    { path: 'certificates', element: <CertificatesCenter /> },
    { path: 'health-vault', element: <HealthVault /> },
    { path: 'share-center', element: <ShareCenter /> },
    { path: 'neoai', element: <NeoAI /> },
    { path: 'vaccinations', element: <Vaccinations /> },
    { path: 'blood-bank', element: <BloodBankReadiness /> },
    { path: 'ecosystem-links', element: <EcosystemLinksPage /> },
    { path: 'claims', element: <ClaimsDocPack /> },
    { path: 'emergency-records', element: <EmergencyRecords /> },
    // Communication — unified My Chat
    { path: 'my-chat', element: <MyChat /> },
    { path: 'communication', element: <Navigate to="/patient/my-chat" replace /> },
    { path: 'chat', element: <Navigate to="/patient/my-chat" replace /> },
    { path: 'calls', element: <Navigate to="/patient/my-chat" replace /> },
    { path: 'telemedicine', element: <Navigate to="/patient/my-chat" replace /> },
    { path: 'groups', element: <Navigate to="/patient/my-chat" replace /> },
    // Phase B: Document Templates & Preview
    { path: 'certificates/preview/:certificateId', element: <CertificatePreview /> },
    { path: 'documents/preview/:documentId', element: <DocumentPreview /> },
    { path: 'documents/templates', element: <DocumentTemplates /> },
    { path: 'documents/downloads', element: <DocumentDownloads /> },
    // Lab Integration Demo
    { path: 'labs', element: <PatientLabDiscovery /> },
    { path: 'labs/:labProfileId', element: <PatientLabProfile /> },
    { path: 'lab-booking/:labProfileId', element: <PatientLabBooking /> },
    { path: 'lab-appointments', element: <PatientLabAppointments /> },
    { path: 'lab-appointments/:id', element: <PatientLabAppointmentDetail /> },
    { path: 'lab-reports', element: <PatientLabReports /> },
    { path: 'lab-invoices', element: <PatientLabInvoices /> },
    { path: 'lab-payments', element: <PatientLabPayments /> },
    { path: 'lab-store/:labProfileId', element: <PatientLabStore /> },
    // Marketplace (old label kept for compatibility)
    { path: 'marketplace', element: <Marketplace /> },
    { path: 'marketplace/providers', element: <ProviderListing /> },
    { path: 'marketplace/providers/:slug', element: <ProviderDetail /> },
    { path: 'marketplace/:type', element: <ProviderListing /> },
    // Redirect old ai-summary to neoai
    { path: 'ai-summary', element: <Navigate to="/patient/neoai" replace /> },
    // APK flow routes
    { path: 'profile', element: <PatientProfile /> },
    { path: 'nhc-card', element: <PatientNHCCard /> },
    { path: 'scan', element: <PatientQRScanner /> },
    { path: 'search', element: <PatientSearch /> },
    { path: 'care-services', element: <CareServicesHub /> },
    // Care Services flows
    { path: 'care-services/doctors', element: <DoctorDiscovery /> },
    { path: 'care-services/doctors/:doctorId', element: <DoctorProfile /> },
    { path: 'care-services/doctors/:doctorId/book', element: <DoctorBooking /> },
    // Lab Tests opens the catalogue of tests, as the Patient app does; the
    // lab directory it used to open is a tap away under /directory.
    { path: 'care-services/labs', element: <LabTestsCatalogue /> },
    { path: 'care-services/labs/directory', element: <LabDiscovery /> },
    { path: 'care-services/labs/compare', element: <LabCompare /> },
    { path: 'care-services/labs/:labId', element: <LabStore /> },
    { path: 'care-services/labs/:labId/book', element: <LabBooking /> },
    { path: 'care-services/pharmacy', element: <PharmacyDiscovery /> },
    { path: 'care-services/pharmacy/:pharmacyId', element: <PharmacyStore /> },
    { path: 'care-services/pharmacy/:pharmacyId/order', element: <PharmacyStore /> },
    { path: 'care-services/imaging', element: <ImagingDiscovery /> },
    { path: 'care-services/imaging/:centerId', element: <ImagingCenter /> },
    // Imaging has no patient booking: POST /appointments refuses an imaging
    // provider outright, so this flow was a 422 every time and blamed the
    // patient's connection for it. The centre page carries the real number.
    { path: 'care-services/imaging/:centerId/book', element: <Navigate to="/patient/care-services/imaging" replace /> },
    { path: 'care-services/hospitals', element: <HospitalDiscovery /> },
    { path: 'care-services/hospital-panel/:hospitalId', element: <HospitalPanelPage /> },
    { path: 'care-services/hospitals/:hospitalId', element: <HospitalProfile /> },
    { path: 'care-services/hospitals/:hospitalId/book', element: <HospitalProfile /> },
    { path: 'care-services/telemedicine', element: <TelemedicinePage /> },
    // The shared teleconsultation — the same session the doctor apps see.
    { path: 'telemedicine/consult/:appointmentId', element: <TeleConsultPage /> },
    { path: 'care-services/ambulance', element: <AmbulancePage /> },
    { path: 'care-services/insurance', element: <InsurancePage /> },
    { path: 'notifications', element: <PatientNotifications /> },
    { path: 'security', element: <PatientSecurity /> },
    { path: 'security/sessions', element: <PatientSecuritySessions /> },
    { path: 'security/two-factor', element: <PatientTwoFactor /> },
    { path: 'medical-basics', element: <PatientMedicalBasics /> },
    { path: 'records', element: <Navigate to="/patient/health-vault" replace /> },
    // New placeholder pages
    { path: 'prescriptions', element: <PatientPrescriptions /> },
    { path: 'diagnostics', element: <PatientDiagnostics /> },
    { path: 'hospital', element: <HospitalRecord /> },
    { path: 'my-requests', element: <MyRequests /> },
    { path: 'neoverify', element: <NeoVerifyCheck /> },
    { path: 'profile/addresses', element: <AddressesAndPreferences /> },
    { path: 'care-plans', element: <CarePlans /> },
    { path: 'nearby', element: <NearbyCare /> },
    { path: 'my-care', element: <MyCare /> },
    { path: 'imaging', element: <Navigate to="/patient/care-services/imaging" replace /> },
    { path: 'documents', element: <PatientDocuments /> },
    { path: 'appointments', element: <PatientAppointments /> },
    // Profile sub-routes (aliased for clean URLs)
    { path: 'profile/registration', element: <PatientRegistration /> },
    { path: 'profile/medical-basics', element: <PatientMedicalBasics /> },
    { path: 'profile/security', element: <PatientSecurity /> },
    { path: 'profile/app-lock', element: <PatientAppLock /> },
    { path: 'profile/legal', element: <PatientLegalCenter /> },
    { path: 'legal/:slug', element: <PatientLegalPage /> },
    // Booking flows — redirect to new care-services
    { path: 'book-doctor', element: <Navigate to="/patient/care-services/doctors" replace /> },
    { path: 'book-lab', element: <Navigate to="/patient/care-services/labs" replace /> },
    // Imaging Discovery & Booking — superseded by the real, backend-wired
    // care-services/imaging flow; these legacy fake-data pages were removed.
    { path: 'imaging-discovery', element: <Navigate to="/patient/care-services/imaging" replace /> },
    { path: 'imaging-booking/:providerId', element: <Navigate to="/patient/care-services/imaging" replace /> },
    // Access log alias
    { path: 'access-log', element: <Navigate to="/patient/access-logs" replace /> },
    // Ambulance alias
    { path: 'ambulance', element: <AmbulanceTrips /> },
  ],
};
